// import React, { useState, useEffect, useCallback } from 'react';
// import {
// 	Button,
// 	Progress
// } from 'reactstrap';
// import Sound from 'react-sound';
// import MicRecorder from 'mic-recorder-to-mp3';
// import SpeechRecognition from 'react-speech-recognition';
// import getBlobDuration from 'get-blob-duration';
// // import { s3base } from "api.js";
// import Beep from "Beep.js";

// import SpeechToText from "components/Question/Speaking/New/SpeechToText";

// import MicWaveform from "components/Question/Speaking/MicWaveform";

// let Mp3Recorder = new MicRecorder({ bitRate: 128 });
// const WAITING = 35;
// const LIMIT = 35;

// const FunctionBox = ({ testMode, ...props }) => {

// 	const [waiting, setWaiting] = useState(true);
// 	const [beep, setBeep] = useState(false);
// 	const [recording, setRecording] = useState(false);
// 	const [requireTranscript, setRequireTranscript] = useState(false);
// 	const [trans, setTrans] = useState("");
// 	const [processComplete, setProcessComplete] = useState(false);
// 	const [file, setFile] = useState(null);
// 	const [duration, setDuration] = useState(0);
// 	const [blobUrl, setBlobUrl] = useState(0);

// 	console.log("Function Box");

// 	/**
// 	 * ComponentWillUnmount
// 	 * stop listening.
// 	 * Stop Recording.
// 	 */
// 	useEffect(() => {
// 		return (() => {
// 			SpeechRecognition.stopListening();
// 			Mp3Recorder.stop();
// 		});
// 	}, []);

// 	console.log("TestMode====", testMode);

// 	// const updateWaitingStatus = (status) => {
// 	// 	setWaiting(status);
// 	// 	props.updateSkipClicked(false);
// 	// 	setBeep(true);
// 	// }

// 	const updateWaitingStatus = useCallback((status) => {
// 		setWaiting(status);
// 		props.updateSkipClicked(false);
// 		setBeep(true);
// 	}, [props.updateSkipClicked]);

// 	const beepComplete = () => {
// 		setBeep(false);
// 		setRecording(true);
// 		props.updateRecordingStatus(true);
// 	}

// 	// const updateRecordingStatus = (status) => {
// 	// 	props.updateRecordingStatus(status);
// 	// 	setRecording(status);
// 	// }
// 	const updateRecordingStatus = useCallback(
// 		(status) => {
// 			props.updateRecordingStatus(status);
// 			setRecording(status);
// 		},
// 		[props.updateRecordingStatus] // only re-create if parent callback changes
// 	);

// 	const stopRecordingAndListening = () => {
// 		if (recording) {
// 			SpeechRecognition.stopListening();
// 			requireTranscriptSet(true); // save transcript to this component.

// 			Mp3Recorder
// 				.stop()
// 				.getMp3()
// 				.then(async ([buffer, blob]) => {

// 					const blobURL = URL.createObjectURL(blob);
// 					const duration = await getBlobDuration(blobURL);
// 					const file = new File([blob], 'noname.mp3', { type: blob.type });
// 					setFile(file);
// 					setDuration(duration);
// 					setBlobUrl(blobURL);

// 					// props.blobUrlSet(blobURL);
// 					setProcessComplete(true);
// 				});
// 		} else {
// 			setProcessComplete(true);
// 		}
// 	}

// 	/**
// 	 * Skip waiting timer.
// 	 */
// 	const skip = () => {
// 		setWaiting(false);
// 		setBeep(true);
// 		props.updateSkipClicked(false);
// 	}

// 	/**
// 	 * Stop Recording.
// 	 */
// 	const stop = () => {
// 		updateRecordingStatus(false);
// 		stopRecordingAndListening();
// 		props.updateStopClicked(false);
// 	}

// 	const requireTranscriptSet = (status) => {
// 		setRequireTranscript(status);
// 	}

// 	/**
// 	 * Transcript.
// 	 */
// 	const setTranscript = (transcript) => {
// 		setTrans(transcript);
// 		requireTranscriptSet(false);
// 	}

// 	/**
// 	 * recording hook.
// 	 */
// 	useEffect(() => {
// 		if (recording) {
// 			Mp3Recorder
// 				.start()
// 				.then(() => {
// 					SpeechRecognition.startListening({ continuous: true, language: 'en-GB' });
// 				});
// 		}
// 	}, [recording]);

// 	/**
// 	 * Recording Process Complete.
// 	 */
// 	useEffect(() => {
// 		if (processComplete) {
// 			setTimeout(() => {
// 				props.submitReadySet({
// 					file,
// 					duration,
// 					blobUrl,
// 					transcript: trans
// 				}); // send message to main read-aloud file that we are ready to submit this question.
// 			}, 100);

// 		}
// 	}, [processComplete]);

// 	/**
// 	 * stopRecording from parent components
// 	 * For mocks.
// 	 */
// 	useEffect(() => {
// 		if (props.stopRecording === true) {
// 			setWaiting(false);
// 			stop();
// 		}
// 	}, [props.stopRecording]);

// 	useEffect(() => {
// 		if (props.skipClicked) {
// 			skip();
// 		}
// 	}, [props.skipClicked]);

// 	useEffect(() => {
// 		if (props.stopClicked) {
// 			stop();
// 		}
// 	}, [props.stopClicked]);

// 	return (
// 		<>
// 			<ul className="recorded-list">
// 				<li>Status:</li>
// 				<li>
// 					<>
// 						{waiting &&
// 							<Waiting
// 								waiting={updateWaitingStatus}
// 								pauseWaiting={props.pauseWaiting}
// 							/>
// 						}

// 						{recording && "Recording Started"}

// 						{!waiting && !beep && !recording && "Recording Finished"}
// 					</>
// 				</li>
// 			</ul>

// 			<div>
// 				{recording ? (
// 					<RecordingProgress
// 						stop={stop}
// 					/>
// 				) : (
// 					<div style={{ height: '5px' }}></div>
// 				)}
// 			</div>

// 			{beep &&
// 				<Sound
// 					url={Beep}
// 					playStatus={Sound.status.PLAYING}
// 					onFinishedPlaying={() => beepComplete()}
// 				/>
// 			}

// 			<SpeechToText
// 				saveTranscript={requireTranscript}
// 				setTranscript={setTranscript}
// 			/>

// 			{/*<div className="audio-box">
// 				<h4>Recorded Answer</h4>
// 				<p><strong>Current status:</strong></p>
// 				<div>
// 					{waiting &&
// 						<Waiting
// 							waiting={updateWaitingStatus}
// 							pauseWaiting={props.pauseWaiting}
// 						/>
// 					}

// 					{beep &&
// 						<Sound
// 							url={`${s3base}/ptedata/ptemedia/beep.mp3`}
// 							playStatus={Sound.status.PLAYING}
// 							onFinishedPlaying={() => beepComplete()}
// 						/>
// 					}

// 					{recording &&
// 						<span>Recording Started</span>
// 					}

// 					{!waiting && !beep && !recording &&
// 						<span>Recording Stopped.</span>
// 					}
// 				</div>

// 				{!props.testMode && waiting &&
// 					<div className='stop-btn'>
// 						<Button color="success" onClick={() => skip()} size="sm">Skip</Button>
// 					</div>
// 				}

// 				{recording &&
// 					<>
// 						{!props.testMode &&
// 							<div className='stop-btn'>
// 								<Button color="success" onClick={() => stop()} size="sm">Stop</Button>
// 							</div>
// 						}

// 						<RecordingProgress
// 							stop={stop}
// 						/>
// 					</>
// 				}

// 				<div className="audo-line">
// 					<span className="progress-bar-fill-Read intro"></span>
// 				</div>
// 			</div>*/}
// 		</>
// 	);
// }

// export default FunctionBox;

// /**
//  * Waiting.
//  */
// const Waiting = React.memo(function Waiting(props) {
// 	const [seconds, setSeconds] = useState(WAITING);
// 	const [timerId, setTimerId] = useState(null);
// 	const [init, setInit] = useState(false);

// 	const watingTimer = (isSubscribed) => {
// 		const id = setInterval(() => {
// 			if (isSubscribed) {
// 				setSeconds(seconds => (seconds - 1));
// 			}
// 		}, 1000);
// 		setTimerId(id);
// 	};

// 	console.log("Waiting render", seconds);

// 	useEffect(() => {
// 		const { pauseWaiting } = props;
// 		if (pauseWaiting) {
// 			clearInterval(timerId);
// 		} else if (init) {
// 			watingTimer(true);
// 		}
// 	}, [props.pauseWaiting]);

// 	useEffect(() => {
// 		let isSubscribed = true;

// 		watingTimer(isSubscribed);

// 		// set init value after 1s.
// 		setTimeout(() => {
// 			setInit(true);
// 		}, 1000);

// 		// component will unmount.
// 		return (() => {
// 			clearInterval(timerId);
// 			isSubscribed = false;
// 		});
// 	}, []);

// 	useEffect(() => {
// 		if (seconds === 0) {
// 			props.waiting(false);
// 			clearInterval(timerId);
// 		}
// 	}, [seconds]);

// 	// return `Recording starts in ${seconds} seconds`;
// 	return (
// 		<>
// 			<div className="mic-waveform-wrapper">
// 				<p>Recording starts in {seconds} seconds</p>
// 				<img src="/images/waveform.png" alt="Waveform" style={{ width: "100%" }} />
// 			</div>
// 		</>
// 	);

// })

// /**
//  * Recording Progress.
//  */
// const RecordingProgress = React.memo(function RecordingProgress(props) {

// 	const [seconds, setSeconds] = useState(0);
// 	const [timerId, setTimerId] = useState(null);
// 	console.log("RecordingProgress render", seconds);
// 	useEffect(() => {
// 		let isSubscribed = true;

// 		const id = setInterval(() => {
// 			if (isSubscribed) {
// 				setSeconds(seconds => (seconds + 1));
// 			}
// 		}, 1000);
// 		setTimerId(id);

// 		// below will execute when component is about to  unmount.
// 		return (() => {
// 			isSubscribed = false;
// 			clearInterval(timerId); // precautionary. just to avoid errors and warnings.
// 		});
// 	}, []);

// 	useEffect(() => {
// 		if (seconds === LIMIT) {
// 			clearInterval(timerId);
// 			props.stop(); // This will cause component unmount.
// 		}
// 	}, [seconds]);

// 	return (
// 		// <Progress
// 		// 	color="info"
// 		// 	value={(seconds*3)}
// 		// 	style={{
// 		// 		height: '5px'
// 		// 	}}
// 		// />
// 		<MicWaveform progressValue={seconds * 3} />

// 	);
// });

import React, { useState, useEffect, useCallback, useRef } from "react";
import Sound from "react-sound";
import Beep from "Beep.js";

import ReusableRecorder from "components/Recorder/ReusableRecorder";
import MicWaveform from "components/Question/Speaking/MicWaveform";
import { isIOSDevice } from 'util/deviceDetection';

const WAITING = 35;
const LIMIT = 35;

const FunctionBox = ({ testMode, ...props }) => {
  const [waiting, setWaiting] = useState(true);
  const [beep, setBeep] = useState(false);
  const [recording, setRecording] = useState(false);
  const [trans, setTrans] = useState("");
  const [processComplete, setProcessComplete] = useState(false);
  const [file, setFile] = useState(null);
  const [duration, setDuration] = useState(0);
  const [blobUrl, setBlobUrl] = useState("");
  const [seconds, setSeconds] = useState(WAITING);
  const timerRef = useRef(null);
  const recorderRef = useRef(null);
  const audioContextRef = useRef(null);
  const waitingCompleted = useRef(false);
  const [recordingSeconds, setRecordingSeconds] = useState(0);


  const updateWaitingStatus = useCallback(
    (status) => {
      setWaiting(status);
      props.updateSkipClicked(false);
      setBeep(true);
      // ✅ Start recording immediately when beep fires — same pattern as DescribeImage.
      // This eliminates the 1-3s delay caused by waiting for the beep to finish.
      setTimeout(() => {
        if (recorderRef.current) {
          recorderRef.current.startRecording();
        }
        setRecording(true);
        props.updateRecordingStatus(true);
      }, 0);
    },
    [props.updateSkipClicked, props.updateRecordingStatus]
  );

  // ✅ beepComplete now ONLY cleans up the beep UI — recording already started above.
  const beepComplete = useCallback(() => {
    setBeep(false);
    setRecordingSeconds(0);
  }, []);

  const updateRecordingStatus = useCallback(
    (status) => {
      props.updateRecordingStatus(status);
      setRecording(status);
    },
    [props.updateRecordingStatus]
  );

  const handleRecordingComplete = useCallback((recordingData) => {
    const { blob, url, transcript, duration: recordDuration } = recordingData;

    const file = new File([blob], "noname.mp3", { type: blob.type });
    setFile(file);
    setDuration(recordDuration);
    setBlobUrl(url);
    setTrans(transcript || "");
    setProcessComplete(true);

    setWaiting(false);
  }, []);

  // ✅ Stable ref so ReusableRecorder never remounts due to handleRecordingComplete identity changing.
  const handleRecordingCompleteRef = useRef(null);
  handleRecordingCompleteRef.current = handleRecordingComplete;

  const stableHandleRecordingComplete = useCallback((data) => {
    handleRecordingCompleteRef.current(data);
  }, []);

  const createAndPlayBeep = useCallback((audioContext) => {
    try {
      const oscillator = audioContext.createOscillator();
      const gainNode = audioContext.createGain();
      oscillator.connect(gainNode);
      gainNode.connect(audioContext.destination);
      oscillator.frequency.value = 800; // 800 Hz beep
      oscillator.type = 'sine';
      gainNode.gain.setValueAtTime(0.3, audioContext.currentTime);
      gainNode.gain.exponentialRampToValueAtTime(0.01, audioContext.currentTime + 0.3);
      oscillator.start(audioContext.currentTime);
      oscillator.stop(audioContext.currentTime + 0.3);

      // ✅ beepComplete only cleans up the beep UI now — recording already started.
      setTimeout(() => {
        beepComplete();
      }, 300);
    } catch (error) {
      console.error('Error playing beep sound:', error);
      setTimeout(() => {
        beepComplete();
      }, 300);
    }
  }, [beepComplete]);

  const playMobileBeep = useCallback(() => {
    if (isIOSDevice()) {
      // iOS needs explicit AudioContext resume
      try {
        const AudioContext = window.AudioContext || window.webkitAudioContext;
        let audioContext = audioContextRef.current;
        if (!audioContext) {
          audioContext = new AudioContext();
          audioContextRef.current = audioContext;
        }
        if (audioContext.state === 'suspended') {
          audioContext.resume().then(() => {
            createAndPlayBeep(audioContext);
          }).catch(() => {
            createAndPlayBeep(audioContext); // try anyway
          });
        } else {
          createAndPlayBeep(audioContext);
        }
      } catch (error) {
        console.error('iOS beep error:', error);
        setTimeout(() => {
          beepComplete();
        }, 300);
      }
    } else {
      // Android – try Web Audio, fallback to setTimeout if needed
      try {
        const AudioContext = window.AudioContext || window.webkitAudioContext;
        let audioContext = audioContextRef.current;
        if (!audioContext) {
          audioContext = new AudioContext();
          audioContextRef.current = audioContext;
        }
        if (audioContext.state === 'suspended') {
          audioContext.resume().then(() => {
            createAndPlayBeep(audioContext);
          }).catch(() => {
            createAndPlayBeep(audioContext);
          });
        } else {
          createAndPlayBeep(audioContext);
        }
      } catch (error) {
        console.error('Android beep error, using fallback', error);
        setTimeout(() => {
          beepComplete();
        }, 300);
      }
    }
  }, [createAndPlayBeep, beepComplete, isIOSDevice]);  

  useEffect(() => {
    if (isIOSDevice() && beep) {
      playMobileBeep();
    }
  }, [beep, playMobileBeep, isIOSDevice]);

  const skip = useCallback(() => {
    setWaiting(false);
    setBeep(true);
    props.updateSkipClicked(false);
    // ✅ Start recording immediately alongside the beep — same pattern as DescribeImage.
    setTimeout(() => {
      if (recorderRef.current) {
        recorderRef.current.startRecording();
      }
      setRecording(true);
      props.updateRecordingStatus(true);
    }, 0);
  }, [props.updateSkipClicked, props.updateRecordingStatus]);

  const stop = useCallback(() => {
    updateRecordingStatus(false);
    if (!props.testMode) {
      props.setIsStopped(false)
    }
    if (recorderRef.current) {
      recorderRef.current.stopRecording();
    } else {
      console.warn("⚠️ [FunctionBox] recorderRef.current is null!");
    }

    props.updateStopClicked(false);
  }, [updateRecordingStatus, props.updateStopClicked]);

  // NOTE: Recording is now started directly in updateWaitingStatus and skip,
  // simultaneously with the beep — so no separate effect is needed here.

  // Submit after processing
  useEffect(() => {
    if (processComplete) {
      setTimeout(() => {
        props.submitReadySet({
          file,
          duration,
          blobUrl,
          transcript: trans,
        });
      }, 100);
    }
  }, [processComplete, file, duration, blobUrl, trans]);

  // Handle parent controls
  useEffect(() => {
    if (props.stopRecording === true) {
      setWaiting(false);
      stop();
    }
  }, [props.stopRecording, stop]);

  useEffect(() => {
    if (props.skipClicked) {
      skip();
    }
  }, [props.skipClicked, skip]);

  // Listen for stop button click from parent (ReadAloud)
  useEffect(() => {
    if (props.stopClicked) {
      // console.log('🔴 [FunctionBox] stopClicked prop changed to true');
      stop();
    }
  }, [props.stopClicked, stop]);

  // useEffect(() => {
  //   if (props.pauseWaiting) {
  //     clearInterval(timerRef.current);
  //     return;
  //   }

  //   timerRef.current = setInterval(() => {
  //     setSeconds((s) => {
  //       if (s <= 1) {
  //         clearInterval(timerRef.current);
  //         updateWaitingStatus(false); // notify parent ONCE
  //         return 0;
  //       }
  //       return s - 1;
  //     });
  //   }, 1000);

  //   return () => clearInterval(timerRef.current);
  // }, [props.pauseWaiting, updateWaitingStatus]);
  
  const updateRecordingSeconds = useCallback((secs) => {
  setRecordingSeconds(secs);
}, []);

  useEffect(() => {
    if (processComplete || !waiting || props.pauseWaiting) {
      clearInterval(timerRef.current);
      return;
    }

    // if (props.pauseWaiting || !waiting) {
    //   clearInterval(timerRef.current);
    //   return;
    // }
     if (waitingCompleted.current) return;
    timerRef.current = setInterval(() => {
      setSeconds((s) => {
        if (s <= 1) {
          clearInterval(timerRef.current);
          // updateWaitingStatus(false);
          if (!waitingCompleted.current) {
            waitingCompleted.current = true;
            updateWaitingStatus(false);
          }
          return 0;
        }
        return s - 1;
      });
    }, 1000);

    return () => clearInterval(timerRef.current);
  }, [props.pauseWaiting, waiting, processComplete, updateWaitingStatus]);

  const recordingLabel = useCallback(() => {
    let label = "";
    if (blobUrl === "" && waiting) {
      label = `Recording starts in ${seconds} seconds...`;
    } else if (blobUrl === "" && recording) {
      label = "Recording audio...";
    } else if (!waiting && !beep && !recording && blobUrl !== "") {
      label = "Recording Finished.";
    } else if (!recording && blobUrl === "" && seconds === 0) {
      label = "Preparing to record...";
    }
    return label;
    }, [seconds, blobUrl, recording,beep]);

  return (
    <>
      <ul className="recorded-list">
        {/* <li>Status:</li>
        <li>
          <>{recordingLabel()}
          </>
        </li> */}
        <li>Status:<span className="text-black"> {recordingLabel()}</span></li>
        {recording && (
      <li>
     Recording: {LIMIT - recordingSeconds}s
    </li>
  )}
      </ul>

      <div className="recording-visual-wrapper">
        {/* {(waiting || ( !recording && blobUrl === "" && seconds === 0)) && <Waiting />}

        {recording && <RecordingProgress stop={stop} />}

        {beep && (
          <div style={{ marginTop: "70px" }}>
            <Sound
              url={Beep}
              playStatus={Sound.status.PLAYING}
              onFinishedPlaying={beepComplete}
            />
          </div>
        )} */}

          {((waiting)) ? <Waiting />
           : !recording && blobUrl === "" && seconds === 0 ?
           <Waiting /> :recording && (
             <RecordingProgress stop={stop} onSecondsUpdate={updateRecordingSeconds}/>
           ) 
        }

        { !isIOSDevice() && beep && (
          <div style={{ marginTop: "70px" }}>
            <Sound
              url={Beep}
              playStatus={Sound.status.PLAYING}
              onFinishedPlaying={beepComplete}
              onError={beepComplete}
            />
          </div>
        )}
      </div>

      <ReusableRecorder
        ref={recorderRef}
        onRecordingComplete={stableHandleRecordingComplete}
        onRecordingStop={() => updateRecordingStatus(false)}
        maxDuration={LIMIT * 1000}
        enableSpeechRecognition={true}
        fileName={"noname.mp3"}
        // stream={props.stream}
      />
    </>
  );
};

export default FunctionBox;

/**
 * Waiting component
 */
// const Waiting = React.memo(function Waiting(props) {
//   const [seconds, setSeconds] = useState(WAITING);
//   const [timerId, setTimerId] = useState(null);
//   const [init, setInit] = useState(false);

//   const watingTimer = (isSubscribed) => {
//     const id = setInterval(() => {
//       if (isSubscribed) {
//         setSeconds((s) => s - 1);
//       }
//     }, 1000);
//     setTimerId(id);
//   };

//   useEffect(() => {
//     const { pauseWaiting } = props;
//     if (pauseWaiting) {
//       clearInterval(timerId);
//     } else if (init) {
//       watingTimer(true);
//     }
//   }, [props.pauseWaiting, init, timerId]);

//   useEffect(() => {
//     let isSubscribed = true;
//     watingTimer(isSubscribed);

//     setTimeout(() => setInit(true), 1000);

//     return () => {
//       clearInterval(timerId);
//       isSubscribed = false;
//     };
//   }, []);

//   useEffect(() => {
//     if (seconds === 0) {
//       props.waiting(false);
//       clearInterval(timerId);
//     }
//   }, [seconds, props, timerId]);

//   return (
//     <div className="mic-waveform-wrapper">
//       <p>Recording starts in {seconds} seconds</p>
//       <img src="/images/waveform.png" alt="Waveform" style={{ width: "100%" }} />
//     </div>
//   );
// });

const Waiting = React.memo(function Waiting() {
  // const [seconds, setSeconds] = useState(WAITING);
  // const timerRef = useRef(null);

  // useEffect(() => {
  //   if (pauseWaiting) {
  //     clearInterval(timerRef.current);
  //     return;
  //   }

  //   timerRef.current = setInterval(() => {
  //     setSeconds((s) => {
  //       if (s <= 1) {
  //         clearInterval(timerRef.current);
  //         waiting(false); // notify parent ONCE
  //         return 0;
  //       }
  //       return s - 1;
  //     });
  //   }, 1000);

  //   return () => clearInterval(timerRef.current);
  // }, [pauseWaiting, waiting]);

  return (
    <div className="mic-waveform-wrapper-read" style={{ marginTop: "48px" }}>
      {/* <p>Recording starts in {seconds} seconds</p> */}
      {/* <img
        src="/images/waveform.png"
        alt="Waveform"
        style={{ width: "100%" }}
      /> */}
    <div className="waveform">
        {Array.from({ length: 100 }).map((_, i) => (
          <div key={i} className="wave-bar" />
        ))}
      </div>
    </div>
  );
});

/**
 * Recording Progress
 */
// const RecordingProgress = React.memo(function RecordingProgress(props) {
//   const [seconds, setSeconds] = useState(0);
//   const [timerId, setTimerId] = useState(null);

//   useEffect(() => {
//     let isSubscribed = true;
//     const id = setInterval(() => {
//       if (isSubscribed) {
//         setSeconds((s) => s + 1);
//       }
//     }, 1000);
//     setTimerId(id);

//     return () => {
//       isSubscribed = false;
//       clearInterval(id);
//     };
//   }, []);

//   useEffect(() => {
//     if (seconds === LIMIT) {
//       clearInterval(timerId);
//       props.stop();
//     }
//   }, [seconds, props, timerId]);

//   return <MicWaveform progressValue={seconds * 3} />;
// });

const RecordingProgress = React.memo(function RecordingProgress({ stop ,onSecondsUpdate }) {
  const [seconds, setSeconds] = useState(0);
  const timerRef = useRef(null);

  useEffect(() => {
    timerRef.current = setInterval(() => {
      setSeconds((s) => {
        if (s >= LIMIT) {
          clearInterval(timerRef.current);
          stop();
          return LIMIT;
        }
         const newSeconds = s + 1;
      onSecondsUpdate?.(newSeconds);  
      return newSeconds;
      });
    }, 1000);

    return () => clearInterval(timerRef.current);
  }, [stop]);

  return <MicWaveform progressValue={seconds * 3} />;
});
